export default "__VITE_ASSET__CvH9PBUT__"